<template>

  <div :class="$style.container">
        <div :class="[$style.header, 
                      open && $style.cardOpen,
                      isMobile && $style.mobileHeader]">
            <div @click="open = !open">
                <h5 :class="[$style.title, isMobile && $style.mobileTitle]">
                    <i v-if="!isMobile" :class="open && $style.iconOpen" class="ni ni-bold-down" />
                    <slot name="title"/>
                </h5>
            </div>

            <div :class="[$style.subtitle,isMobile && $style.mobileSubtitle]">
                <slot name="subtitleApplyDeadline"/> 
                <slot name="subtitleAnnounceDeadline"/> 
                <slot name="subtitleNumber"/> 
            </div>

            <div :class="[$style.tag ,isMobile && $style.mobileTag]">
                <slot name="tag"/>
            </div>
        </div>

        <div :class="[open && $style.open,
                      $style.detail, 
                      isMobile && $style.mobileDetail]"> 
            <div :class="$style.white">
                <slot name="white"/> 
            </div>

            <div :class="$style.gray">
                <slot name="gray"/> 
            </div> 
        </div>
  </div>

</template>

<style lang="scss" module>

  .container{
    margin:0 auto;
  }

  .header {
    position: relative;
    min-height: 110px;
    margin:0 auto;
    margin-top: 15px; 
    border-radius: 2px;
    border:1px solid rgba(0,0,0,.095);
    box-shadow: 0 2px 14px 0 rgba(229, 229, 229, .5);
    padding: 20px;

    
    &.mobileHeader{
      padding-bottom: 50px;
    }    

    &.cardOpen{
      box-shadow: 0 0 0px 0 rgba(229, 229, 229, .5);
    }

    color: #9f9f9f; 
    cursor: pointer;
    :hover {
        color: #505050;
    }
    
    .title {
      font-size:20px;

      &.mobileTitle{
        font-size:14px;
      }

    }

    .subtitle {
        font-size:15px; 
        color:gray;
        margin-top:10px;
        margin-left:15px;
        
        :not(:last-child):after {
          content:"|";
        }

      &.mobileSubtitle{
        margin-left:0px;
      }

      &.mobileSubtitle :not(:last-child):after{
        content:"";
      }

      &.mobileSubtitle span{
        font-size:10px;
        display:block;
      }
    }

    .tag {
        position:absolute;
        right:14px;
        bottom:10px;
    }

    .iconOpen {
        transform: rotate(180deg);
    }

    i {
      line-height:30px;
    }
  }


  .detail{
    position: relative;
    display: none;
    border:1px solid rgba(0,0,0,.095);
    border-top-style:none;
    box-shadow: 0 2px 14px 0 rgba(229, 229, 229, .5);
    margin:0 auto;

    &.mobileDetail{
      font-size:14px;
    }

    &.open {
      display: block;
      transition: display 1s linear;
    }    

    .white{
      padding:27px 25px;
    }

    .gray {
      background-color:#F4F5F7;
      padding:27px 25px;
    }
  }

</style>


<script>

import { mapState } from 'vuex'

export default {
  name: "listCard",

  data() {
    return {
     open: false,
    }
  },

  mounted: function() {
    this.open= this.autoOpen
  },

  computed: {
    ...mapState({
      isMobile: state => state.ui.isMobile
    }),
  },

  props: {
    autoOpen: {
      type: Boolean,
    }
  }  
}

</script>

